import { createFileRoute } from "@tanstack/react-router"
import CalendarPage from "@/components/coreAnalytics/events/CalendarPage"

export const Route = createFileRoute("/core/analytics/calendar")({
  component: CalendarPage
})
